import { createRoot } from 'react-dom/client';
import { captureException } from '@sentry/browser';
import { App } from './App';
import '../shared/utils/i18n';

const selector = '.autocomplete-searchbox';

const containers = document.querySelectorAll(selector);

document.addEventListener('DOMContentLoaded', () => {
  if (containers.length) {
    containers.forEach((container) => {
      const root = createRoot(container);
      const staticSearchField: HTMLInputElement | null = container.querySelector('search__input');
      const initialSearchValue = staticSearchField?.value ?? '';

      root.render(<App initialSearchValue={initialSearchValue} />);
    });
  } else {
    captureException(new Error(`Could not find ${selector}`));
  }
});
